import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import Loader from "../../control-components/loader/loader";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import { clinicService } from "../../services/clinicService";
import { useNavigate } from "react-router";
import APP_ROUTES from "../../helper/app-routes";
import searchIcon from "../../assets/images/search.png";
import { Input, Switch } from "@progress/kendo-react-inputs";
import { MaskFormatted } from "../../helper/mask-helper";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { useDispatch, useSelector } from "react-redux";
import { GET_CLINIC_LIST_SELECTED_STATE, GET_CLINIC_STATUS, GET_CLINIC_STATES, GET_SELECTED_CUSTOMER_STATUS, SHOW_CLINICS_WITH_SMS_NOTIFICATIONS, SHOW_CLINICS_WITHOUT_STRIPE_GLOBAL_STATE, SHOW_RCM_CLINICS_GLOBAL_STATE } from "../../actions";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import moment from "moment";
import InputKendoRct from "../../control-components/input/input";
import API_URLS from "../../helper/api-urls";
import apiHelper from "../../helper/api-helper";
import ClinicExportToExcel from "./clinicExportToExcel";
import CustomSplitButton from "src/control-components/split-button";
import UpdateCustomerStatus from "./clinic-Actions/change-Customer-Status";
import { CUSTOMER_STATUS_BADGE_STYLE, getCustomerStatusConfig } from "src/helper/customer-status-config";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const status = [
  {
    id: 1,
    isActive: true,
    name: "Active",
  },
  {
    id: 2,
    isActive: false,
    name: "Inactive",
  },
];


function Clinic() {
  const clinicStatusGlobalState = useSelector(
    (state) => state.clinicStatusReducer
  );
  const clinicSelectedState = useSelector(
    (state) => state.clinicsSelectedStateReducer
  );
  const showClinicsWithoutStripeIdGlobalState = useSelector(
    (state) => state.clinicToggleForStripeReducer
  );
  const showClinicsWithSmsNotificationGlobalState = useSelector(
    (state) => state.clinicToggleForSmsNotificationsReducer
  );

  const showRCMClinicsGlobalState = useSelector(
    (state) => state.clinicToggleForRCMReducer
  );
  const customerStatusGlobalState = useSelector(
    (state) => state.selectedCustomerStatusReducer
  );
  const statesData = useSelector(
    (state) => state.clinicStatesReducer
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = useState([]);
  const [selectedState, setSelectedState] = React.useState({});
  const [loading, setLoading] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [searching, setSearching] = useState(false);
  const [clinic, setClinic] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchApiQuery, setsearchApiQuery] = useState([]);
  const defaultValue = status.find((item) => item.isActive) || status[0];
  const [clinicStatus, setClinicStatus] = useState(defaultValue);
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [trigger, setTrigger] = useState(false);
  const [isStateFetched, setStateFetched] = useState(false);
  const [showClinicsWithoutStripeId, setShowClinicsWithoutStripeId] = useState(false);
  const [showClinicsWithSmsNotifications, setShowClinicsWithSmsNotifications] = useState(false);
  const [showRCMClinics, setShowRCMClinics] = useState(false);
  const [showEditStripeIdDialog, setShowEditStripeIdDialog] = useState(false);
  const [newStripeIdForDialog, setNewStripeIdForDialog] = useState('')
  const [masterClinicId, setMasterClinicId] = useState()
  const [regionId, setRegionId] = useState()
  const [ActionItemEditor] = useState([
    { id: 1, name: "Update Customer Status", iconClass: "fa fa-flag" },
  ]);
  const [isOpenCustomerStatus, setIsOpenCustomerStatus] = useState(false);
  const [, setIsAssign] = useState(false);
  const showSplitButton = Object.values(selectedState).some(Boolean);
 
  const [customerStatuses, setCustomerStatuses] = useState([]);
  useEffect(() => {
    if (clinicStatusGlobalState === false) {
      setPage(0)
      getAllClinic();
    } else if (clinicStatus !== false) {
      setClinicStatus(clinicStatusGlobalState);
      setPage(0)
      getAllClinic();
    }
  }, [trigger]);

  useEffect(() => {
    if (!isStateFetched) {
      getAllStates();
      setStateFetched(true);
      getCustomerStatuses();
    }
  }, [isStateFetched]);

  useEffect(() => {
    if (clinic.length > 0) {
      if (showClinicsWithoutStripeIdGlobalState) {
        setShowClinicsWithoutStripeId(showClinicsWithoutStripeIdGlobalState);
        if (showClinicsWithoutStripeIdGlobalState === true) {
          setClinic((prevItems) => prevItems.filter(item => item.stripeCustomerId === null));
        } else {
          setClinic((prevItems) => prevItems);
        }
      }
    }
  }, [showClinicsWithoutStripeIdGlobalState, clinic.length]);

  useEffect(() => {
    if (clinic.length > 0) {
      if (showClinicsWithSmsNotificationGlobalState) {
        setShowClinicsWithSmsNotifications(showClinicsWithSmsNotificationGlobalState);
        if (showClinicsWithSmsNotificationGlobalState === true) {
          setClinic((prevItems) => prevItems.filter(item => item.enableTextReminders === showClinicsWithSmsNotificationGlobalState));
        } else {
          getAllClinic();
        }
      }
    }
  }, [showClinicsWithSmsNotificationGlobalState, clinic.length]);

  useEffect(() => {
    if (clinic.length > 0) {
      if (showRCMClinicsGlobalState) {
        setShowRCMClinics(showRCMClinicsGlobalState);
        if (showRCMClinicsGlobalState === true) {
          setClinic((prevItems) => prevItems.filter(item => item.isRCM === showRCMClinicsGlobalState));
        } else {
          getAllClinic();
        }
      }
    }
  }, [showRCMClinicsGlobalState, clinic.length]);

  const handleAddClinic = () => {
    navigate(APP_ROUTES.ADD_CLINIC);
  };

  const getAllClinic = async () => {
    setLoadingList(true);
    setClinic([])
    setsearchApiQuery([])
    await clinicService
      .getAllClinic({
        region: null,
        isActive: !clinicStatusGlobalState
          ? clinicStatus.isActive
          : clinicStatusGlobalState.isActive,
        state: clinicSelectedState?.id || null,
        isRCM: showRCMClinicsGlobalState ? true : null,
        customerStatusId: customerStatusGlobalState?.id || null
      })
      .then((result) => {
        if (result.resultData.length > 0) {
          setClinic(result.resultData);
          setsearchApiQuery(result.resultData);
        } else {
          setClinic([])
          setsearchApiQuery([])
        }
        setTimeout(() => setLoadingList(false), 500)

      })
      .catch((error) => {
        setLoadingList(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  };

  const getAllStates = async () => {
    setLoading(true);
    await clinicService
      .getAllClinicStates()
      .then((result) => {
        dispatch({
          type: GET_CLINIC_STATES,
          payload: result?.resultData || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  };
  const getCustomerStatuses = async () => {
    try {
      const result = await clinicService.getCustomerStatuses();
  
      if (result?.resultData) {
        setCustomerStatuses(result.resultData);
      }
    } catch (error) {
      NOTIFICATION_MESSAGE.error(error);
    }
  };

  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
    setSelectedState({});
  };

  function handleChangeForSwitch(e) {
    const value = e.target.value;
    setShowClinicsWithoutStripeId(value);
    dispatch({
      type: SHOW_CLINICS_WITHOUT_STRIPE_GLOBAL_STATE,
      payload: value,
    });

    if (value === true) {
      setClinic((prevItems) => prevItems.filter(item => item.stripeCustomerId === null));
    } else {
      getAllClinic()
    }
  }


  function handleSubmitNewStripeId() {
    if (newStripeIdForDialog) {
      const data = {
        id: masterClinicId,
        stripeCustomerId: newStripeIdForDialog,
        regionId: regionId,
      }
      apiHelper.postRequest(API_URLS.UPDATE_STRIPE_CUSTOMER_ID, data)
        .then((result) => {
          setLoading(false);
          setShowEditStripeIdDialog(false);
          NotificationManager.success('Stripe Customer ID updated successfully')
          getAllClinic();
          setNewStripeIdForDialog('')
          setRegionId('')
          setMasterClinicId('')
        })
        .catch((error) => {
          setLoading(false);
          setShowEditStripeIdDialog(false);
          NotificationManager.error(error.message);
          setNewStripeIdForDialog('')
          setRegionId('')
          setMasterClinicId('')
        });
    }
    else {
      NotificationManager.error('Please enter a Stripe Customer ID to continue')
    }

  }

  function handleCancelNewStripeId() {
    setShowEditStripeIdDialog(false)
    setNewStripeIdForDialog('')
    setRegionId('')
    setMasterClinicId('')
  }

  function handleEditStripeIdClick(custId, masterClinicId, regionId) {
    setShowEditStripeIdDialog(true);
    setNewStripeIdForDialog(custId);
    setRegionId(regionId)
    setMasterClinicId(masterClinicId)
  }

  const handleChange = (e) => {
    const selectedItem = e.target.value;
    const selectedItemName = e.target.name;
  
    if (selectedItemName === "name") {
      if (selectedItem !== null) {
        dispatch({
          type: GET_CLINIC_STATUS,
          payload: selectedItem,
        });
      }
    } 
    else if (selectedItemName === "customerStatus") {
      dispatch({
        type: GET_SELECTED_CUSTOMER_STATUS,
        payload: selectedItem,
      });
    } 
    else {
      if (selectedItem && selectedItem !== null) {
        dispatch({
          type: GET_CLINIC_LIST_SELECTED_STATE,
          payload: selectedItem,
        });
      } else {
        dispatch({
          type: GET_CLINIC_LIST_SELECTED_STATE,
          payload: null,
        });
      }
    }
  
    setTrigger((prev) => !prev);
  };




  const handleFilter = (e) => {
    if (e.target.value === "") {
      setClinic(searchApiQuery);
    } else {
      setClinic([])
      setSearching(true)
      const filterResult = searchApiQuery.filter(
        (item) =>
          item.clinicName
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          Number(item.masterClinicId)
            .toString()
            .toLowerCase()
            .includes(Number(e.target.value).toString().toLowerCase())
      );
      setTimeout(() => {
        setClinic(filterResult);
        setSearching(false)
      }, 400)
    }
    setSearchQuery(e.target.value);
  };


  const showConfirmPopup = (obj) => {
    setShowConfirm(true);
    setDeleteUser(obj);
  };

  const hideConfirmPopup = () => {
    setShowConfirm(false);
    setDeleteUser("");
  };

  const InactiveClinic = async () => {
    setLoading(true);
    await clinicService
      .deleteClinic(deleteUser)
      .then((result) => {
        NotificationManager.success("Clinic deleted successfully.");
        setLoading(false);
        getAllClinic();
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error.message);
      });
    hideConfirmPopup();
  };

  const activeClinic = async () => {
    setLoading(true);
    const data = {
      isActive: !clinicStatus.isActive,
      masterClinicId: deleteUser.id,
    };
    await clinicService
      .updateClinicStatus(data)
      .then((result) => {
        setLoading(false);
        NotificationManager.success(NOTIFICATION_MESSAGE.CLINIC_STATUS);
        getAllClinic();

        navigate(APP_ROUTES.CLINIC);
      })
      .catch((error) => {
        setLoading(false);
        NOTIFICATION_MESSAGE.error(error);
      });
    hideConfirmPopup();
  };

  const handleClinicInfo = (field) => {
    const url = `${field}.notenetic.com`;
    window.open(`https://${url}`, '_blank');
  };
  const handleSelectAction = (e) => {
        const value = e.item.text;
        setIsOpenCustomerStatus(false);

        if (value === "Update Customer Status") {
            setIsOpenCustomerStatus(!isOpenCustomerStatus);
            setIsAssign(true);
        }
    };

    const handleSelectionChange = (event) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });
      setSelectedState(newSelectedState);
    }

    const onHeaderSelectionChange = (event) => {
      const checked = event.nativeEvent.target.checked;
      const newSelectedState = { ...selectedState, ...event.select };
      if (!checked) {
        Object.keys(newSelectedState).forEach(key => { newSelectedState[key] = false; });
      }
      setSelectedState(newSelectedState);
      setSelectedState(newSelectedState);
    }

        

  return (
    <>
      <h4 className="address-title text-grey ">
        <span className="f-24">Clinic</span>
      </h4>
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-2">
        <div className="">
          <div className="d-flex align-items-center gap-2 ">
            <div className="content-search-filter ">
              <img src={searchIcon} alt="" className="search-icon" />
              <Input
                className="icon-searchinput"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => handleFilter(e)}
              />
            </div>
            <div style={{ marginBottom: "1.3rem" }}>
              <DropDownKendoRct
                filterable={true}
                label="Status"
                onChange={handleChange}
                data={status}
                value={clinicStatus}
                textField="name"
                name="name"
                dataItemKey="id"
                suggest={true}
              />
            </div>
            <div className="edit-Service-popup"style={{ marginBottom: "1.3rem" }}>
              <DropDownKendoRct
                filterable={true}
                label="State"
                onChange={handleChange}
                data={statesData}
                value={clinicSelectedState}
                textField="stateName"
                name="states"
                dataItemKey="id"
                suggest={true}

              />
            </div>
            <div
              className="edit-Service-popup"
              style={{ marginBottom: "1.3rem" }}
            >
              <DropDownKendoRct
                filterable={true}
                label="Customer Status"
                onChange={handleChange}
                data={customerStatuses}
                value={customerStatusGlobalState}
                textField="statusName"
                name="customerStatus"
                dataItemKey="id"
                suggest={true}
              />
            </div>
          </div>
          <div className="d-flex align-items-center gap-2 ">
            <div>
              <Switch
                value={showClinicsWithoutStripeId}
                name={"showClinicsWithoutStripeId"}
                onChange={handleChangeForSwitch}
                checked={showClinicsWithoutStripeId}
              />
              <span className="ml-2 mt-2">Clinics w/o Stripe ID</span>
            </div>
            <div>
              <Switch
                value={showClinicsWithSmsNotifications}
                name="showClinicsWithSmsNotifications"
                onChange={(e) => {
                  const newValue = e.target.value;
                  setShowClinicsWithSmsNotifications(newValue);
                  dispatch({
                    type: SHOW_CLINICS_WITH_SMS_NOTIFICATIONS,
                    payload: newValue,
                  });
                  if (newValue) {
                    setClinic((prevItems) => prevItems.filter(item => item.enableTextReminders === newValue));
                  } else {
                    getAllClinic();
                  }
                }}
                checked={showClinicsWithSmsNotifications}
              />
              <span className="ml-2 mt-2">Clinics w/ SMS notifications</span>
            </div>
            <div>
              <Switch
                value={showRCMClinics}
                name="showRCMClinics"
                onChange={(e) => {
                  const newValue = e.target.value;
                  setShowRCMClinics(newValue);
                  dispatch({
                    type: SHOW_RCM_CLINICS_GLOBAL_STATE,
                    payload: newValue,
                  });
                  if (newValue) {
                    setClinic((prevItems) => prevItems.filter(item => item.isRCM === !showRCMClinics));
                  } else {
                    getAllClinic();
                  }
                }}
                checked={showRCMClinics}
              />
              <span className="ml-2 mt-2">RCM Clinics</span>
            </div>
          </div>
        </div>
   
        <div className="d-flex align-items-center gap-2">
          {showSplitButton &&
            <CustomSplitButton
              items={ActionItemEditor}
              text="Clinic Actions"
              onChange={handleSelectAction}
              size={"medium"}
            />
           } 
          <ClinicExportToExcel clinicList={clinic} />
          <button className="green-btn btn-primary mt-1" onClick={handleAddClinic}>
            <span
              className="fa fa-plus"
              style={{ color: "#fff" }}
            ></span>{" "}
            Add Clinic
          </button>
        </div>
      </div>
      <div className="grid-table  filter-grid">
        <div className=" mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table  filter-grid header-blue">
              <div className=" mt-3">
                {(loading === true || loadingList) ? <Loader /> :
                  (clinic.length < 1 && searching) ? <div>Searching</div> :
                    (!loading && !loadingList && clinic.length < 1 && searching) ? <div>No data available</div>
                      : <Grid
                        data={orderBy(clinic.slice(page, pageSize + page), sort).map(
                          (item) => ({
                            ...item,
                            [SELECTED_FIELD]: selectedState[idGetter(item)],
                          })
                        )}
                        checkboxElement
                        style={{
                          height: clinic.length > 0 ? "100%" : "250px",
                        }}
                        dataItemKey={DATA_ITEM_KEY}
                        selectedField={SELECTED_FIELD}
                        skip={page}
                        take={pageSize}
                        total={clinic.length}
                        onPageChange={pageChange}
                        pageable={{
                          pageSizes: [10, 20, 30, 100, 500],
                        }}
                        sort={sort}
                        sortable={true}
                        onSortChange={(e) => {
                          setSort(e.sort);
                        }}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                        selectable={{
                          enabled: true,
                          mode: 'multiple',
                          drag: false,
                          cell: false,
                          checkboxOnly: true,
                        }}
                        onSelectionChange={handleSelectionChange}
                      >
                        <GridColumn
                          filterable={false}
                          columnType="checkbox"
                          locked={true}
                          width="60px"

                        />
                     
                        <GridColumn
                          className="cursor-default"
                          title="Clinic ID"
                          width="250px"
                          cells={{
                            data: (props) => {
                              let field = props.dataItem;

                              const status = field?.customerStatusName;
                              const config = getCustomerStatusConfig(status);

                              return (
                                <td
                                  className="text-theme"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    navigate(APP_ROUTES.CLINIC_INFO, {
                                      state: { field },
                                    })
                                  }
                                >
                                  <div className="d-flex align-items-center gap-2 flex-wrap">

                                    <span
                                      className="text-theme fw-semibold"
                                      style={{ fontSize: "13px" }}
                                    >
                                      {field?.masterClinicId}
                                    </span>

                                    <div
                                      style={{
                                        ...CUSTOMER_STATUS_BADGE_STYLE,
                                        background: config.bg,
                                        color: config.color,
                                        border: `1px solid ${config.border}`,
                                        padding: "2px 8px",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <i
                                        className={config.icon}
                                        style={{
                                          fontSize: "10px",
                                          opacity: 0.9,
                                        }}
                                      />

                                      <span>{status}</span>
                                    </div>

                                  </div>
                                </td>
                              );
                            },
                          }}
                        />
                        <GridColumn
                          className="cursor-default"
                          title="Clinic Name"
                          width="150px"
                          field="clinicName"
                        />
                        <GridColumn
                          className="cursor-default"
                          title="Domain Name"
                          width="150px"
                          cells={{
                            data: (props) => {
                              let field = props.dataItem;
                              return (
                                <td
                                  className="text-theme"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleClinicInfo(field?.domainName)}
                                >
                                  {field?.domainName}
                                </td>
                              );
                            }
                          }}
                        />
                        <GridColumn
                          className="cursor-default"
                          title="Stripe Customer ID"
                          width="150px"
                          cells={{
                            data: (props) => {
                              let field = props.dataItem;
                              return (
                                <td style={{ wordWrap: 'break-word' }}>
                                  {field.stripeCustomerId}
                                  <div
                                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2"
                                    onClick={() => handleEditStripeIdClick(field.stripeCustomerId, field.id, field.regionId)}
                                  >
                                    <div className="k-chip-content">
                                      <Tooltip anchorElement="target" position="top">
                                        <i className="fas fa-edit" title="Update"></i>
                                      </Tooltip>
                                    </div>
                                  </div>
                                </td>
                              );
                            }
                          }}
                        />
                        <GridColumn
                          className="cursor-default"
                          field="regionName"
                          title="Region Name"
                          width="150px"
                        />
                        <GridColumn
                          className="cursor-default"
                          field="status"
                          title="Status"
                          width="150px"
                        />
                        <GridColumn
                          className="cursor-default"
                          field="Address"
                          width="200px"
                          max-width="30px"
                          min-width="150px"
                          cells={{
                            data: (props) => {
                              let field = props.dataItem;
                              return (
                                <td>
                                  {field.address ||
                                    field.state ||
                                    field.city ||
                                    field.zip ? (
                                    <>
                                      <p className="mb-0">
                                        <b>Address</b>:{" "}
                                        {field.address === null ? "" : field.address}
                                      </p>
                                      <p className="mb-0">
                                        <b>city</b>:{" "}
                                        {field.city === null ? "" : field.city}
                                      </p>
                                      <p className="mb-0">
                                        <b>state</b>:{" "}
                                        {field.state === null ? "" : field.state}
                                      </p>
                                      <p className="mb-0  ">
                                        <b>zip</b>:{" "}
                                        {field.zip === null
                                          ? ""
                                          : field.zip.length != 9
                                            ? field.zip
                                            : `${field.zip.substring(
                                              0,
                                              5
                                            )}-${field.zip.substring(5)}`}
                                      </p>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              );
                            }
                          }}
                        />
                        <GridColumn
                          className="cursor-default"
                          field="Phone"
                          width="150px"
                          cells={{
                            data: (props) => {
                              let field = props.dataItem.phone;
                              return <td>{MaskFormatted(field, "(999) 999-9999")}</td>;
                            }
                          }}
                        />

                        <GridColumn
                          className="cursor-default wrap-text"
                          field="email"
                          title="Email"
                          width="200px"
                        />

                        <GridColumn
                          className="cursor-default"
                          title="Text Reminders"
                          width="150px"
                          field="enableTextReminders"
                          cells={{
                            data: (props) => {
                              let field = props?.dataItem?.enableTextReminders;
                              return <td>
                                <span>
                                  {field ? (
                                    "Yes"
                                  ) : (
                                    'No'
                                  )}
                                </span>
                              </td>;
                            }
                          }}
                        />

                        <GridColumn
                          className="cursor-default"
                          title="User Seats"
                          width="200px"
                          cells={{
                            data: (props) => {
                              let max = props.dataItem.maxAllowedUserSeats;
                              let use = props.dataItem.activeStaffCount;
                              let userSeats=props.dataItem.startingUserCounts;
                              return (
                                <td>
                                  <div className="d-flex flex-column">
                                    <div className="d-flex align-items-center">
                                      <strong>Used:</strong>
                              
                                      <span className="ml-1">
                                        {use}
                                      </span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <strong>Total:</strong>
                              
                                      <span className="ml-1">
                                        {max}
                                      </span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <strong>Initial:</strong>
                              
                                      <span className="ml-1">
                                        {userSeats}
                                      </span>
                                    </div>
                              
                                  </div>
                                </td>
                              );
                            }
                          }}
                        />

                        <GridColumn
                          className="cursor-default"
                          title="Join Date"
                          width="150px"
                          cells={{
                            data: (props) => {
                              return <td>{props?.dataItem?.utcDateCreated != null ? moment(props?.dataItem?.utcDateCreated).format("MM/DD/YYYY") : "N/A"}</td>;
                            }
                          }}
                        />

                        <GridColumn
                          className="cursor-default"
                          title="Subscription Start Date"
                          width="190px"
                          cells={{
                            data: (props) => {
                              return <td>{props?.dataItem?.subscriptionStartDate != null ? moment(props?.dataItem?.subscriptionStartDate).format("MM/DD/YYYY") : "N/A"}</td>;
                            }
                          }}
                        />

                        <GridColumn
                          className="cursor-default"
                          title="Commission %"
                          width="150px"
                          cells={{
                            data: (props) => {
                              return <td>{props?.dataItem?.commissionPercentage != null ? props?.dataItem?.commissionPercentage : ""}</td>;
                            }
                          }}
                        />

                        <GridColumn
                          className="cursor-default"
                          title="Sales Person"
                          width="150px"
                          cells={{
                            data: (props) => {
                              return <td>{props?.dataItem?.salesPerson || ""}</td>;
                            }
                          }}
                        />

                        <GridColumn
                          className="cursor-default"
                          title="Referral"
                          width="150px"
                          cells={{
                            data: (props) => {
                              return <td>{props?.dataItem?.referral || ""}</td>;
                            }
                          }}
                        />

                        <GridColumn
                          className="cursor-default"
                          title="Last log in"
                          width="150px"
                          cells={{
                            data: (props) => {

                              return <td>{props?.dataItem?.utcLastLogin != null ? moment(props?.dataItem?.utcLastLogin).format("MM/DD/YYYY") : "N/A"}</td>;
                            }
                          }}
                        />


                        <GridColumn
                          width={150}
                          title="Action"
                          filterable={false}
                          cells={{
                            data: (props) => {
                              let field = props.dataItem;
                              return (
                                <td>
                                  <div className="row-3">
                                    <div
                                      className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red"
                                      onClick={() => showConfirmPopup(field)}
                                    >
                                      <div className="k-chip-content">
                                        <Tooltip anchorElement="target" position="top">
                                          <i
                                            className={
                                              clinicStatus.isActive === true
                                                ? "fa fa-trash"
                                                : "fa fa-rotate-left"
                                            }
                                            aria-hidden="true"
                                            title={
                                              clinicStatus.isActive === true
                                                ? "Deactivate"
                                                : "Reactivate"
                                            }
                                          ></i>
                                        </Tooltip>
                                      </div>
                                    </div>
                                    <div
                                      className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2"
                                      onClick={() =>
                                        navigate(APP_ROUTES.ADD_CLINIC, {
                                          state: field,
                                          selectedStatus: clinicStatus,
                                        })
                                      }
                                    >
                                      <div className="k-chip-content">
                                        <Tooltip anchorElement="target" position="top">
                                          <i className="fas fa-edit" title="Edit"></i>
                                        </Tooltip>
                                      </div>
                                    </div>

                                    <div
                                      className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green mr-2"
                                      onClick={() =>
                                        navigate(APP_ROUTES.CLINIC_INFO, {
                                          state: { field },
                                        })
                                      }
                                    >
                                      <div className="k-chip-content">
                                        <Tooltip anchorElement="target" position="top">
                                          <i
                                            className="fas fa-eye"
                                            title="Clinic View"
                                          ></i>
                                        </Tooltip>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              );
                            }
                          }}
                        />
                      </Grid>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {showConfirm ? (
        <Dialog
          className="xs-modal"
          title={"Please confirm"}
          onClose={hideConfirmPopup}
        >
          <p
            style={{
              margin: "25px",
            }}
          >
            Are you sure you want to{" "}
            {clinicStatus.isActive ? "Deactivate" : "Reactivate"} Clinic?
          </p>
          <DialogActionsBar>
            {clinicStatus.isActive ? (
              <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={InactiveClinic}
              >
                Yes
              </button>
            ) : (
              <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={activeClinic}
              >
                Yes
              </button>
            )}
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={hideConfirmPopup}
            >
              No
            </button>
          </DialogActionsBar>
        </Dialog>
      ) : (
        ""
      )}
      {showEditStripeIdDialog && (
        <Dialog
          onClose={handleCancelNewStripeId}
          title={"Update Stripe Customer ID"}
          className="small-dailog"
          width={'25%'}
        >
          <div className="edit-client-popup">
            <div className="popup-modal slibling-data">
              <div className="row">
                <div className="mt-2">
                  <InputKendoRct
                    value={newStripeIdForDialog}
                    onChange={(e) => setNewStripeIdForDialog(e.target.value)}
                    name="newStripeIdForDialog"
                    label="Stripe Customer ID"
                    className="form-control"
                    placeholder="Stripe Customer ID"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="border-bottom-line"></div>
          <div className="d-flex my-3">
            <div className="right-sde">
              <button className="green-btn btn-primary mx-3" onClick={handleSubmitNewStripeId}>
                Update
              </button>
            </div>
            <div className="right-sde-grey">
              <button
                className="btn grey-secondary text-white "
                onClick={handleCancelNewStripeId}
              >
                Cancel
              </button>
            </div>
          </div>
        </Dialog>
      )}
      {isOpenCustomerStatus && (
        <UpdateCustomerStatus
          clinicIds={Object.entries(selectedState)
            .filter(([, v]) => v)
            .map(([k]) => Number(k))}
            onClose={() => {
              setSelectedState({});
              setIsOpenCustomerStatus(false);
            }}
            onClear={() => {
              setSelectedState({});
              setIsOpenCustomerStatus(false);
            }}
          getAllClinic={getAllClinic}
        />
      )}
    </>
  );
}
export default Clinic;
